(function (module) {
    'use strict';

    function AddGroupCtrl(Group, $state) {

        this.addGroup = () => {
            Group
                .create(this.group)
                .$promise
                .then((group) => {
                    $state.go('root.groups.view',{ id: group.id });
                })
                .catch((error) => {
                    return error;
                });
        };

    }

    module
        .config(($stateProvider) => {
            $stateProvider
                .state('root.groups.add', {
                    url: '/add',
                    data: {
                        pageTitle: 'PLAYERS_ADD.PAGE_TITLE'
                    },
                    views: {
                        'content@root': {
                            template: '<group-add-component />'
                        }
                    }
                });
        })
        .component('groupAddComponent', {
            templateUrl: '/js/groups/add-group/add-group.html',
            controller: AddGroupCtrl
        });
})(angular.module('rocket.components'));
